import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'

const ZCreateAssetApiResponse = z.object({
  id: z.string(),
  name: z.string(),
  serial_number: z.string(),
  install_date: z.string(),
  asset_type_id: z.string(),
  asset_type_name: z.string(),
  timezone: z.string(),
  application_type: z.string(),
  description: z.string()
})

export interface CreateAssetRegistrationPostRequest {
  name: string
  serial_number: string
  install_date: string
  asset_type_id: string
  timezone: string
  application_type: string
  description: string
}

const ZApiResponse = z.object({
  http_status: z.number(),
  data: ZCreateAssetApiResponse,
  error: z.boolean()
})

export type CreateAssetApiResponse = z.infer<typeof ZCreateAssetApiResponse>

export async function createAssetRegistration (
  createAssetPostRequest: CreateAssetRegistrationPostRequest,
  onSuccess: (successResponse: CreateAssetApiResponse, httpStatus: number) => any,
  onFailure: (errorMessage: string, httpStatus: number) => any
): Promise<void> {
  const url = '/assetrest/api/v2/udp/tiq/assets/asset-management'

  interceptedAxios
    .post(url, createAssetPostRequest, { timeout: 15000 })
    .then((response) => {
      const parseResponse = ZApiResponse.safeParse(response.data)

      if (parseResponse.success) {
        onSuccess(parseResponse.data.data, parseResponse.data.http_status)
      } else {
        onFailure('Error occurred while processing response', response.status)
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        if (error.response.data !== undefined) {
          onFailure(error.response.data.error_message ?? error.response.data.message ?? 'Request failed', error.response.data.http_status ?? error.response.status)
        } else {
          onFailure(error.response.statusText, error.response.status)
        }
      } else {
        onFailure('Network Failure', error.status)
      }
    })
}
